import { Task, Timestamp } from '@griply/types';

import { hasNoSchedules, isTaskTypeTask } from './task-predicates';

// a repeating task's date comes from its schedule; a deadline is never its date — row deadline flags use getTaskDeadline
export const getEffectiveDeadline = (task: Task): Timestamp | null => {
  if (!isTaskTypeTask(task) || !hasNoSchedules(task)) {
    return null;
  }

  const deadlines = [
    task.endStrategy?.deadline?.getTime(),
    task.deadlineDeadline?.getTime(),
  ].filter((timestamp): timestamp is number => typeof timestamp === 'number');

  return deadlines.length ? new Date(Math.min(...deadlines)) : null;
};
